import React from "react";
import EmptyState from "components/EmptyState";
import { useParams } from "react-router";
import { buildingStore } from "store/Building/BuildingStore";
import Retool from ".";

const DataQualityDashboard = () => {
  const reportID = "5246b456-b0c4-11ef-9241-fbdc5d67c0f2";
  const { id: BuildingId } = useParams();

  const embeddedData = {
    building_id: BuildingId,
  };

  if (!buildingStore.buildingMappingStatus.hasReport)
    return (
      <EmptyState
        type="inventory"
        loading={buildingStore.calculationsStatus.inProgress}
        containerClassName="m-6"
      />
    );

  return (
    <Retool
      url={reportID}
      embeddedData={embeddedData}
      className="h-[calc(100vh-120px)]"
    />
  );
};

export default DataQualityDashboard;
